import { render, staticRenderFns } from "./radios.vue?vue&type=template&id=6f805a90&scoped=true&"
import script from "./radios.vue?vue&type=script&lang=js&"
export * from "./radios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f805a90",
  null
  
)

export default component.exports